<template>
  <div>
    <v-autocomplete
      v-model="userId"
      @change="$emit('user-selected', $event)"
      :loading="loading"
      :items="items"
      :search-input.sync="search"
      cache-items
      flat
      label="Search for a user"
      clearable
    ></v-autocomplete>
  </div>
</template>

<script>
import { CLIENTS_SIMPLE_SEARCH_QUERY } from "@/graphql/queries/user";

export default {
  name: "UserSearch",
  props: {
    onlyStaff: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      keyUpSearchInterval: null,
      users: null,
      search: null,
      limit: 16,
      loading: null,
      userId: null,
    };
  },
  watch: {
    search(val) {
      if (this.keyUpSearchInterval) {
        clearTimeout(this.keyUpSearchInterval);
        this.keyUpSearchInterval = null;
      }
      this.keyUpSearchInterval = setTimeout(() => {
        this.doSearch();
      }, 1000);
    },
  },
  computed: {
    items() {
      if (!this.users) {
        return [];
      }
      return this.users.map((user) => {
        return {
          text: `${user.firstName} ${user.lastName} - ${user.email}`,
          value: user.id,
        };
      });
    },
  },
  methods: {
    doSearch() {
      if (!this.search) {
        return;
      }
      this.loading = true;
      let data = {
        first: this.limit,
        search: this.search,
        userIsStaff: this.onlyStaff,
      };

      this.$apollo
        .query({
          query: CLIENTS_SIMPLE_SEARCH_QUERY,
          variables: data,
        })
        .then((response) => {
          let users = [];
          for (const userNode of response.data.clients.edges) {
            let user = {
              userProfile: {},
            };
            user.id = userNode.node.user.id;
            user.firstName = userNode.node.user.firstName;
            user.lastName = userNode.node.user.lastName;
            user.email = userNode.node.user.email;

            users.push(user);
          }
          this.users = users;
        });
      this.loading = false;
    },
  },
};
</script>
